var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"d-print-block",class:{ 'd-none': _vm.hide }},[_c('img',{staticClass:"img img-fluid",attrs:{"src":_vm.enterprise.logo,"alt":_vm.enterprise.name}}),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }